import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CreativeTemplatePropType from "common/prop-types/creative-template-prop-type";
import InstagramStory from "./instagram-story";
import InstagramReel from "./instagram-reel";
import CreatomateAdPreview from "./creatomate-ad-preview";
import "./phone-placeholder.styles.scss";

const propTypes = {
  creative: CreativeTemplatePropType.isRequired,
  facebookPage: PropTypes.shape({
    name: PropTypes.string,
    picture: PropTypes.string
  }).isRequired,
  facebookNewsfeedData: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    domain: PropTypes.string
  }).isRequired,
  isMobile: PropTypes.bool,
  uniqueKey: PropTypes.string.isRequired
};

const InstagramPhonePlaceholder = ({
  creative,
  facebookPage,
  facebookNewsfeedData,
  isMobile = false,
  uniqueKey
}) => {
  const MAX_WIDTH = 378;
  const reductionRate = MAX_WIDTH / creative.width;
  const creativeHeight = creative.height * reductionRate;

  return (
    <div className="py-4">
      <div
        className={classNames([
          "ad-preview__iphone-placeholder",
          "ad-preview__iphone-placeholder--instagram",
          { "ad-preview__iphone-placeholder--mobile": isMobile }
        ])}
      >
        <div className="ad-preview__iphone-placeholder-container">
          {creative.primaryMimeType === "video/mp4" || creative.isCreatomateTemplate ? (
            <InstagramReel mediaSrc={`${creative.previewPath}?ts=${new Date().getTime()}`}>
              <CreatomateAdPreview
                key={uniqueKey}
                creative={creative}
                width={MAX_WIDTH}
                height={creativeHeight}
              />
            </InstagramReel>
          ) : (
            <InstagramStory
              profileImage={facebookPage.picture}
              username={facebookPage.name}
              subtitle="Sponsored"
              body={facebookNewsfeedData.body}
              mediaSrc={`${creative.previewPath}?ts=${new Date().getTime()}`}
            />
          )}
        </div>
      </div>
      <small className="pt-3">
        Ad rendering and interaction may vary based on device, format and other factors.
      </small>
    </div>
  );
};

InstagramPhonePlaceholder.propTypes = propTypes;

export default InstagramPhonePlaceholder;
